import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  //   Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CardContent,
  TablePagination,
} from "@mui/material";
import { Grid } from "@material-ui/core";
import EditIcon from "../../assets/images/editIcon.svg";
import DeleteIcon from "../../assets/images/deleteIcon.svg";
import adminServices from "../../services/adminServices";
import CircularProgress from "@mui/material/CircularProgress";
import {
  addBudgetFormData,
  TableBudgetFormData,
} from "../../types/adminSection";
import filter from "../../assets/images/adminSection/filter.svg";
import download from "../../assets/images/adminSection/download-02.svg";
import SaveIcon from "@mui/icons-material/Save";
import { showToast } from "../../components/common/toastNotification";
import toast from "react-hot-toast";
import CustomInput from "../../components/common/inputField";
import AddIcon from "../../assets/images/AddIcon.svg";
import AddBudgetModal from "../adminModals/AddBudget";
import AutoCompleteUserSelect, {
  UserOption,
} from "../../components/AutoCompleteUserSelect/AutoCompleteUserSelect";
import CustomSelect from "../../components/common/customSelect";
import dashboardService from "../../services/DashboardServices";
import DeleteModal from "../../components/common/DeleteModal";

export interface DropDownOption {
  label: string;
  value: string;
}

export interface Option {
  label: string;
  value: string;
}
const BudgetListingView = () => {
  //   const navigate = useNavigate();
  const [tableData, setTableData] = useState<TableBudgetFormData[]>([]);

  const [divisionOptions, setDivisionOptions] = useState<Option[]>([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  const [selectedUserByName, setSelectedUserByName] =
    useState<UserOption | null>(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPageCount, setTotalPageCount] = useState(10);
  const [showFilters, setShowFilters] = useState(false);
  const [isAddBudgetModalFormOpen, setIsAddBudgetModalFormOpen] =
    useState(false);
  const [formData, setFormData] = useState<TableBudgetFormData>({
    name: "",
    eCode: "",
    divisionName: "",
    functionName: "",
    designationName: "",
    hrManagerName: "",
  });
  const [formErrors, setFormErrors] = useState<
    Partial<TableBudgetFormData & { general?: string }>
  >({});
  const [editRowId, setEditRowId] = useState<number | null>(null);
  const [editFormData, setEditFormData] = useState<TableBudgetFormData>({
    allocatedIndividualBudget: "",
    allocatedCrossFunctionalBudget: "",
  });
  const [isDownloading, setIsDownloading] = useState(false);
  // get table list function
  const fetchTableData = useCallback(
    async (filters?: addBudgetFormData) => {
      const input: addBudgetFormData = {
        pageNo: page + 1,
        pageSize,
        eCode: filters?.eCode ?? null,
        divisionName: filters?.divisionName ?? null,
        functionName: filters?.functionName ?? null,
        hrManagerName: filters?.hrManagerName ?? null,
      };

      try {
        const response = await adminServices.GetBudgetTableData(input);
        setTableData(response.data.data);
        setTotalPageCount(response.data.data[0].totalRecord);
      } catch (error) {
        console.error("Failed to fetch table data", error);
        setTableData([]);
      }
    },
    [page, pageSize]
  );
  useEffect(() => {
    fetchTableData();
    fetchDivisions();
  }, [page, pageSize, fetchTableData]);

  const fetchDivisions = async () => {
    try {
      const { data } = await dashboardService.getDivisionListAPI();
      if (data?.success) {
        setDivisionOptions(
          (data.data as Array<Record<string, string>>)?.map((item) => ({
            label: item.division,
            value: item.division,
          })) || []
        );
      }
    } catch (error) {
      console.error("Failed to fetch divisions", error);
    }
  };

  const handleSearch = () => {
    const errors: typeof formErrors = {};

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    setFormErrors({});
    const payload: addBudgetFormData = {
      pageNo: page + 1,
      pageSize: pageSize,
      eCode: selectedUserByName?.id || null,
      divisionName: formData.divisionName || null,
      functionName: formData.functionName || null,
    };

    fetchTableData(payload);
  };

  //// Delete function
  const handleDeleteData = async () => {
    if (deleteId === null) return;

    try {
      const response = await adminServices.deleteBudgetAPI(deleteId);
      if (response?.data?.success) {
        showToast("Budget deleted successfully", "success");
        fetchTableData();
      } else {
        showToast(response?.data?.message || "Failed to delete", "error");
      }
    } catch (err) {
      showToast("API error while deleting", "error");
    } finally {
      setIsDeleteModalOpen(false);
      setDeleteId(null);
    }
  };
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditClick = (row: TableBudgetFormData) => {
    setEditRowId(row.id ?? null);
    setEditFormData({
      allocatedIndividualBudget:
        row.allocatedIndividualBudget?.toString() ?? "",
      allocatedCrossFunctionalBudget:
        row.allocatedCrossFunctionalBudget?.toString() ?? "",
    });
  };

  const handleSave = async (row: TableBudgetFormData) => {
    const payload = {
      id: row.id,
      name: row.name,
      eCode: row.eCode,
      divisionName: row.divisionName,
      functionName: row.functionName,
      designationName: row.designationName,
      hrManagerName: row.hrManagerName,
      allocatedIndividualBudget: Number(editFormData.allocatedIndividualBudget),
      allocatedCrossFunctionalBudget: Number(
        editFormData.allocatedCrossFunctionalBudget
      ),
    };

    try {
      await adminServices.updateBudgetDataAPI(payload);
      fetchTableData();
      setEditRowId(null);
    } catch (error) {
      console.error("Failed to update data", error);
    }
  };

  //   download excel function

  const handleExportExcel = async () => {
    setIsDownloading(true);
    const exportPayload: addBudgetFormData = {
      pageNo: page + 1,
      pageSize: pageSize,
      eCode: selectedUserByName?.id || null,
      divisionName: formData.divisionName || null,
      functionName: formData.functionName || null,
      hrManagerName: formData.hrManagerName || null,
    };

    try {
      const response = await adminServices.BudgetTableExport(exportPayload);
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileURL = window.URL.createObjectURL(blob);
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "Budget_Dashboard_Export.xlsx");

      document.body.appendChild(fileLink);
      fileLink.click();
      document.body.removeChild(fileLink);
      toast.success("Excel file exported successfully.");
    } catch (error) {
      console.error("Excel export failed.", error);
    } finally {
      setIsDownloading(false);
    }
  };
  const handleClear = () => {
    setFormData({
      name: "",
      eCode: "",
      divisionName: "",
      functionName: "",
      designationName: "",
      hrManagerName: "",
    });
    setSelectedUserByName(null);
    fetchTableData();
  };
  const handleDropDownOnChange = (event: {
    target: { name: string; value: string | number };
  }) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  return (
    <>
      <Box p={3}>
        {/* Table and Filter/Download Buttons */}
        <Card
          sx={{
            backgroundColor: "#212121",
            mb: 2,
            borderRadius: 0,
            boxShadow: "none",
          }}
        >
          <CardContent>
            <Grid
              container
              style={{
                marginBottom: 8,
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ color: "#fff", fontWeight: "bold" }}>
                Financial Year 2024-2025
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", sm: "space-between" },
                  flexDirection: { xs: "column", sm: "row" },
                  gap: { xs: 2, sm: 0 },
                }}
              >
                <Button
                  className="filterBtn f-14"
                  sx={{
                    borderRadius: 0,
                    background: "#212121",
                    minWidth: { xs: 140, sm: 140 },
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0 15px",
                  }}
                  onClick={() => setShowFilters((prev) => !prev)}
                >
                  <Typography>Filter</Typography>
                  <img src={filter} alt="filter" />
                </Button>

                <Button
                  className="downloadBtn f-14"
                  variant="contained"
                  sx={{
                    borderRadius: 0,
                    background: "#212121",
                    minWidth: { xs: 140, sm: 140 },
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: { xs: 0, sm: 2 },
                    alignItems: "center",
                  }}
                  onClick={handleExportExcel}
                  disabled={isDownloading}
                >
                  <Typography>Download</Typography>
                  <Box>
                    {isDownloading ? (
                      <CircularProgress
                        size={20}
                        sx={{ color: "#fff", marginTop: 1 }}
                      />
                    ) : (
                      <img
                        src={download}
                        width={20}
                        style={{ marginTop: 7 }}
                        alt="download"
                      />
                    )}
                  </Box>
                </Button>

                <Button
                  className="filterBtn f-14"
                  sx={{
                    borderRadius: 0,
                    background: "#212121",
                    minWidth: { xs: 140, sm: 140 },
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0 15px",
                    marginLeft: { xs: 0, sm: 2 },
                  }}
                  onClick={() => setIsAddBudgetModalFormOpen(true)}
                >
                  <Typography>Add</Typography>
                  <img src={AddIcon} alt="filter" />
                </Button>
              </Box>
            </Grid>
            {showFilters && (
              <Box
                sx={{
                  backgroundColor: "#5D5D5D",
                  padding: 2,
                  borderRadius: "4px",
                  marginTop: 2,
                }}
              >
                <Grid
                  container
                  spacing={2}
                  style={{ backgroundColor: "#5D5D5D", padding: 2 }}
                >
                  <Grid item xs={12} md={4}>
                    {" "}
                    <AutoCompleteUserSelect
                      label="Employee Name"
                      placeholder="Enter Employee Name"
                      value={selectedUserByName}
                      backgroundColor="#5D5D5D"
                      onChange={(user) => {
                        setSelectedUserByName(user);
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <CustomSelect
                      name="divisionName"
                      backgroundColor="#5D5D5D"
                      label="Division Name"
                      placeHolder="Enter Division Name"
                      value={formData.divisionName ?? ""}
                      onChange={handleDropDownOnChange}
                      options={divisionOptions}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <CustomInput
                      name="functionName"
                      backgroundColor="#5D5D5D"
                      label="Function Name"
                      placeholder="Enter Function Name"
                      value={formData.functionName ?? ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          functionName: e.target.value,
                        }))
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Button
                      className="otherButton f-14"
                      variant="contained"
                      style={{
                        borderRadius: 0,
                        backgroundColor: "#5D5D5D",
                        width: 140,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: 20,
                      }}
                      onClick={handleSearch}
                    >
                      Search
                    </Button>
                    <Button
                      className="otherButton f-14"
                      variant="contained"
                      style={{
                        borderRadius: 0,
                        backgroundColor: "#5D5D5D",
                        width: 140,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: 20,
                      }}
                      onClick={() => handleClear()}
                    >
                      Clear
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* Table Section */}
            <TableContainer
              sx={{
                backgroundColor: "#212121",
                padding: 0,
                minHeight: "300px",
              }}
            >
              <Table sx={{ overflow: "scroll" }}>
                <TableHead>
                  <TableRow>
                    {[
                      "Employee Name",
                      "E-Code",
                      "Division",
                      "Function",
                      "Designation",
                      "HR Manager",
                      "Budget (Individual/Team)",
                      "Cross Functional Budget",
                      "Utilized Budget For Individual/ Team",
                      "Utilized Budget For Cross Functional",
                      "Available Budget For Individual/ Team",
                      "Available Budget For Cross Functional",
                      "Action",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          color: "#fff",
                          background: "#0A0A0A",
                          fontWeight: "600",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={12}
                        sx={{
                          color: "#fff",
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        No data available.
                      </TableCell>
                    </TableRow>
                  ) : (
                    tableData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ color: "#fff", minWidth: 100 }}>
                          {row.name}
                        </TableCell>

                        <TableCell sx={{ color: "#fff", minWidth: 60 }}>
                          {row.eCode}
                        </TableCell>

                        <TableCell sx={{ color: "#fff", minWidth: 100 }}>
                          {row.divisionName}
                        </TableCell>

                        <TableCell sx={{ color: "#fff", minWidth: 100 }}>
                          {row.functionName}
                        </TableCell>
                        <TableCell sx={{ color: "#fff", minWidth: 100 }}>
                          {row.designationName}
                        </TableCell>
                        <TableCell sx={{ color: "#fff", minWidth: 130 }}>
                          {row.hrManagerName}
                        </TableCell>
                        <TableCell sx={{ color: "#fff", minWidth: 150 }}>
                          {editRowId === row.id ? (
                            <CustomInput
                              label=""
                              type="text"
                              name="allocatedIndividualBudget"
                              onChange={handleInputChange}
                              marginBottom="0px"
                              placeholder=""
                              value={editFormData.allocatedIndividualBudget}
                              backgroundColor="transparent"
                            />
                          ) : (
                            row.allocatedIndividualBudget
                          )}
                        </TableCell>
                        <TableCell sx={{ color: "#fff", minWidth: 150 }}>
                          {editRowId === row.id ? (
                            <CustomInput
                              label=""
                              type="text"
                              marginBottom="0px"
                              name="allocatedCrossFunctionalBudget"
                              onChange={handleInputChange}
                              placeholder=""
                              value={
                                editFormData.allocatedCrossFunctionalBudget
                              }
                              backgroundColor="transparent"
                            />
                          ) : (
                            row.allocatedCrossFunctionalBudget
                          )}
                        </TableCell>
                        <TableCell sx={{ color: "#fff", minWidth: 130 }}>
                          {row.usedIndividualBudget}
                        </TableCell>
                        <TableCell sx={{ color: "#fff", minWidth: 130 }}>
                          {row.usedCrossFunctionalBudget}
                        </TableCell>
                        <TableCell sx={{ color: "#fff", minWidth: 130 }}>
                          {row.availableIndividualBudget}
                        </TableCell>
                        <TableCell sx={{ color: "#fff", minWidth: 140 }}>
                          {row.availableCrossFunctionalBudget}
                        </TableCell>
                        <TableCell sx={{ color: "#fff", minWidth: 80 }}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            {editRowId === row.id ? (
                              <SaveIcon
                                style={{
                                  cursor: "pointer",

                                  width: 20,
                                  height: 20,
                                }}
                                onClick={() => handleSave(row)}
                              />
                            ) : (
                              <img
                                src={EditIcon}
                                alt="Edit"
                                style={{ cursor: "pointer" }}
                                width={20}
                                height={20}
                                onClick={() => handleEditClick(row)}
                              />
                            )}

                            <img
                              src={DeleteIcon}
                              alt="Delete"
                              style={{
                                marginLeft: "8px",
                                cursor: "pointer",
                              }}
                              width={20}
                              height={20}
                              onClick={() => {
                                setDeleteId(row.id ?? null);
                                setIsDeleteModalOpen(true);
                              }}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
            <Grid
              style={{
                justifyContent: "flex-end",
                alignItems: "center",
                display: "flex",
                marginTop: 16,
                padding: 8,
              }}
            >
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                component="div"
                count={totalPageCount}
                rowsPerPage={pageSize}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => {
                  setPageSize(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                sx={{
                  color: "#ffffff",
                  "& .MuiSelect-icon": { color: "#ffffff" },
                  "& .MuiSvgIcon-root": { color: "#ffffff" },
                }}
              />
            </Grid>
          </CardContent>
        </Card>
      </Box>
      {/* ------------ Add Budget Form Pop Up ------------------- */}

      <AddBudgetModal
        onSave={() => {}}
        open={isAddBudgetModalFormOpen}
        onClose={() => {
          setIsAddBudgetModalFormOpen(false);
          fetchTableData();
        }}
      />

      <DeleteModal
        open={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setDeleteId(null);
        }}
        onDelete={handleDeleteData}
      />
    </>
  );
};

export default BudgetListingView;
